import {
  ArchiveIcon,
  CloseIcon,
  CompleteIcon,
  CopyPaste,
  DeleteIcon,
  EyeCrossIcon,
  GlobeIcon,
  GoogleProblem,
  LockIcon,
  PlusIcon,
  PriorityIcon
} from 'assets/icons'
import { SubmitHandler, Controller } from 'react-hook-form'
import Button from 'components/buttons/Button'
import LoadingContainer from 'components/containers/LoadingContainer'
import Switch from 'components/form/Switch'
import MembersList from 'components/lists/MembersList'
import NotesList from 'components/lists/NotesList'
import RemindersList from 'components/lists/RemindersList'
import PopupSection from 'components/popup/PopupSection'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { ChangeEvent, ReactNode, useEffect, useState, useRef } from 'react'
import {
  AccountDoc,
  DocType,
  EventDoc,
  EventStatus,
  GroupDoc,
  ParticipantDeliveryStatusType,
  TaskType,
  UserSettingsDoc
} from 'types/api/changes'
import { Model } from 'types/model'
import * as EventPopupStyled from './styled'
import CalendarSection from './CalendarSection'
import * as Styled from '../styled'
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog'
import EventRecurrenceComponent from 'components/eventComponents/EventRecurrence'
import { EventLocationRow } from 'components/eventComponents/EventLocation'
import AddReminderPopup from './AddReminderPopup'
import { useEventDetails } from 'hooks/useEventDetails'
import { useEventActions } from 'components/providers/EventActionsProvider'
import Grid from '@mui/material/Grid'
import IconButton from 'components/buttons/IconButton'
import { Box, Fade, Stack, TextField, Typography } from '@mui/material'
import {
  GoingBar,
  groupcalStatusToGoogle
} from 'components/eventComponents/GoingBar'
import {
  localEventByLocalId,
  RemoveTempEvents
} from 'services/db/Queries/Event'
import Logger from 'services/Logger'

import {
  fetchAndSaveEventFromServer,
  updateEventOnServer,
  updateParticipantStatus,
  UpdateParticipantStatusBody
} from 'services/api/event'
import { AxiosError } from 'axios'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import {
  featureToMinimumTierNeeded,
  isGroupBlockedToAddEvents,
  isGroupOutOfTier,
  isUserActiveInGroup,
  isUserAdminInGroup,
  isUserCanOperateEvents
} from 'utils/api/groups'
import { APP_COLOR } from 'utils/colors'
import { theme } from 'theme'
import dayjs from 'dayjs'
import { GENERIC_ERROR } from 'utils/strings'
import { highestActiveTier, Tier } from 'utils/api/accounts'
import OutOfTierDialog from 'components/tier/OutOfTierDialog'
import {
  ADD_EVENT_CANNOT_POST_ITEMS,
  EDIT_EVENT_CAN_CHANGE_ONLY_OWNERS,
  EDIT_EVENT_CANNOT_CHANGE_EVENT,
  OUT_OF_TIER
} from 'utils/api/codes'
import { BlockedFlow } from 'analytics/Analytics'
import { KeyboardEvent } from 'react'
import i18n from '../../../i18n'
import { t } from 'i18next'
import { CurrentConvertedCalendars } from 'utils/google_events'
import { SelectableItem } from '../SelectItemWithSearchPopup'
import ParticipantsList from 'components/lists/ParticipantList'
import { isOwnerForGroup } from 'services/db/utils/GroupUtils'
import { LoadingSpinner } from 'components/containers/styled'
import { useConnection } from 'components/providers/ConnectionProvider'
import { ResyncCalendarDialog } from 'components/dialogs/ResyncGoogleDialog'
import Database from 'services/db/Database'
import AllDayRow from './AllDayRow'
import StartEndDateRows from './StartEndDateRows'
import EventsActionsMenu from './EventsActionMenu'
import RecurrentActionDialog from 'components/dialogs/RecurrentActionDialog'
import { makeStyles } from '@mui/styles'
import GroupcalTooltip from 'components/tooltips/GroupcalTooltip'
import { allGroups, allGroupsForUI } from 'services/db/Queries/GroupQueries'
import { UserSettings } from 'services/db/Queries/UserSettingsQueries'
import { isGroupHidden } from 'utils/api/userSettings'
import { is24meApp, isGroupcalApp } from 'utils/appType'
import LabelsSection from './LabelsSection'
import TypeSegment from './TypeSegment'
import { AppUIType, useAppUIType } from 'components/providers/AppUITypeProvider'
import NotesSection from './notesSection/NotesSection'
import { instanceStatus } from 'components/calendar/components/Event'
import { getStringSizeInKB } from 'utils/file'
import { docTypeToString } from 'utils/doc'
import {
  groupIdToPrefix,
  groupIdToProvider,
  groupIdToProviderTypeName,
  groupToProvider,
  isConvertedGroup,
  isConvertedGroupId,
  ProviderType
} from 'utils/groups'
import { useCalendarSync } from 'components/providers/CalendarSyncProdivder'
import { isMobileDevice } from 'utils/constants'
import { useCalendar } from 'components/providers/CalendarProvider'
import BlockOverlay from 'components/BlockOverlay'
import { CalendarSectionItem } from '../CalendarSelectPopup'
import { GraphError } from '@microsoft/microsoft-graph-client'
import { getDefaultTimezone } from 'index'
import { MiscText } from 'components/login/styled'
import dateToTimeString from 'components/calendar/components'
import ColorsPopup from '../ColorsPopup'
import {
  addColorToMetaData,
  appendNoteWithMetaData,
  clearNote
} from 'utils/note_meta_data'
import { isTrulyEmpty, removePrefix } from 'utils/object'
import { useEventPopover } from 'components/calendar/eventPopover/EventPopoverProvider'
import { ClickAwayListener } from '@material-ui/core'
import { isEventRecurring } from 'utils/api/instance_state'
import { isEventBooked, provideEventTitle } from 'utils/event'
import { TierFeatures } from 'utils/api/group_state'
import EventCoverImage, { getCoverImageNote } from './EventCoverImage'
import GalleryButton from './GalleryButton'
import SmallEventDialog from './SmallEventDialog'
import { needShowCoverImage } from 'utils/user'

export enum RECUR_SAVE_TYPE {
  THIS = 'this',
  THIS_AND_FOLLOWING = 'thisAndFollowing',
  ALL = 'all'
}

export interface ContentProps {
  event: Model<EventDoc> | EventDoc
  group?: Model<GroupDoc> | GroupDoc
  userSettings: Model<UserSettingsDoc> | UserSettingsDoc
  onClose: (simpleClose?: boolean, forceClose?: boolean) => void
  open: boolean
  instanceStart: number
  instanceEnd: number
  account: Model<AccountDoc> | AccountDoc
  doNotScrollToEvent?: boolean
  fc_id: string
  awayClickTriggered: boolean
  setAwayClickTriggered: (b: boolean) => void
  showSmallUI: boolean
}

const useStyles = makeStyles({
  root: {
    '& .MuiInput-underline': {
      '&:before': {
        borderBottom: 'none'
      },
      '&:after': {
        borderBottom: 'none'
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: 'none'
      }
    }
  }
})

export function EventPopupContent(props: ContentProps) {
  const { deleteEvent, pendingDeleteEvent } = useEventActions()
  const { setPreventClose, closePopover, setOnOutsideClick } = useEventPopover()
  const titleInputRef = useRef<HTMLTextAreaElement | HTMLInputElement>(null)

  const newEvent =
    (props.event?._id == undefined || props.event?._id?.length == 0) &&
    props.event.local_id?.length === 0

  useEffect(() => {
    setTimeout(() => {
      LocalStorage.set(
        LocalStorageKey.VISIBLE_EVENT,
        (props.event?._id ?? '') + props.instanceStart
      )
    }, 250)
  }, [props.open])

  useEffect(() => {
    if (newEvent && titleInputRef.current) {
      const textLength = titleInputRef.current.value.length
      titleInputRef.current.setSelectionRange(textLength, textLength)
    }
  }, [newEvent])
  Logger.debug('s:', props.instanceStart, 'e:', props.instanceEnd)
  Logger.debug('EventPopup:event', props.event)
  Logger.debug('EventPopup:group', props.group)

  const classes = useStyles()
  const connection = useConnection()
  const calendarSync = useCalendarSync()
  const calendar = useCalendar()

  const eventHook = useEventDetails(
    props.event,
    props.group,
    props.instanceStart,
    props.instanceEnd,
    props.doNotScrollToEvent
  )
  // load event details if needed
  useEffect(() => {
    const provider = groupToProvider(props.group)
    if ((props.event.ParentTaskID?.length ?? 0) > 0 && provider) {
      calendarSync
        .loadEventDetails(props.event.ParentTaskID ?? '', provider)
        .then((event) => {
          // update all needed fields here

          if (event.Recurrence) eventHook.setRecurrence(event.Recurrence, false)
          setNeedShowReccurenceDialog(true)
        })
    }
  }, [props.event._id])

  const isCurrentGroupIsThirdPartyCalendar =
    eventHook.taskType === TaskType.personalEvent

  const activeTier = highestActiveTier(props.account)
  const appUiContext = useAppUIType()

  const [showOutOfTierDialog, onShowOutOfTierDialog] = useState(false)

  const { shouldShowGoingBar, isContextMenuOpen, setIsContextMenuOpen } =
    useEventActions()

  const [timeZoneOpen, setTimeZoneOpen] = useState(false)

  const userId = LocalStorage.get(LocalStorageKey.USER_ID) ?? ''

  const [needShowReccurenceDialog, setNeedShowReccurenceDialog] = useState(
    !!props.event.Recurrence &&
      typeof props.event.Recurrence !== 'string' &&
      Object.keys(props.event.Recurrence).length !== 0 &&
      ((props.event._id?.length ?? 0) > 0 ||
        (props.event.local_id?.length ?? 0) > 0) &&
      eventHook.someday !== '1'
  )
  const [showRecurrenceDialog, setShowRecurrenceDialog] = useState(false)

  const [showCalendarSync, onShowCalendarSync] = useState(false)

  function handleEventServerError(e: any) {
    eventHook.setLoading(false)
    if (e instanceof GraphError) {
      if (e.statusCode === 405) {
        onShowCalendarSync(true)
      } else {
        eventHook.setError(parseErrorToMessage(e, props.event._id))
      }
    } else if (e instanceof AxiosError) {
      if (
        isCurrentGroupIsThirdPartyCalendar &&
        eventHook.getValues('TaskType') === TaskType.personalEvent
      ) {
        if (
          e.response?.status === 405 ||
          e.response?.status === 400 ||
          e.response?.status === 401 ||
          CurrentConvertedCalendars.length === 0
        ) {
          onShowCalendarSync(true)
        } else {
          eventHook.setError(parseErrorToMessage(e, props.event._id))
        }
      } else {
        eventHook.setError(parseErrorToMessage(e, props.event._id))
      }
    } else {
      eventHook.setError(parseErrorToMessage(e, props.event._id))
      Logger.red(e)
    }
  }

  const processEvent = async (data: EventDoc) => {
    Logger.blue('UPDATE_EVENT', data)

    // fix empty location fields
    if (
      data.Location &&
      isTrulyEmpty(data.Location.Lat) &&
      typeof data.Location !== 'string'
    ) {
      data.Location.Lat = '0'
    }

    if (
      data.Location &&
      isTrulyEmpty(data.Location.Long) &&
      typeof data.Location !== 'string'
    ) {
      data.Location.Long = '0'
    }

    if (
      data.Location &&
      isTrulyEmpty(data.Location.FilteredLocation) &&
      typeof data.Location !== 'string'
    ) {
      data.Location.FilteredLocation = 'null'
    }

    data.Text = data.Text?.trim()

    delete data['noteText']
    delete data['id']

    // check data be less than 2MB
    const dataString = JSON.stringify(data)
    const dataSizeInKB = getStringSizeInKB(dataString)
    const dataSizeInMB = dataSizeInKB / 1024

    Logger.debug('Doc size in MB', dataSizeInMB)

    if (dataSizeInMB > 2) {
      eventHook.setError(
        i18n.t('sizeTooLarge', {
          name: docTypeToString(data.Type).toLowerCase()
        }) ?? ''
      )
      return
    }

    await eventHook.isLocalSaveOnly().then((isLocalSave) => {
      if (
        needShowReccurenceDialog &&
        eventHook.someday !== '1' &&
        !isLocalSave
      ) {
        setShowRecurrenceDialog(true)
      } else {
        LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
        return eventHook
          .sendEventToServer(data)
          .then(() => {
            props.onClose(false, true)

            if (
              eventHook.dirtyFields['AllDay'] ||
              (isLocalSave && isEventRecurring(data))
            ) {
              closePopover()
            } else {
              setTimeout(() => {
                closePopover()
              }, 250)
            }

            if (appUiContext.uiType.value != AppUIType.calendars) {
              switch (data.Type) {
                case DocType.EVENT:
                  appUiContext.goToCalendar()
                  break
                case DocType.TASK:
                  appUiContext.goToTasks()
                  break
                case DocType.NOTE:
                  appUiContext.goToNotes()
                  break
              }
              closePopover()
            }
          })
          .catch((e) => {
            // print stack trace of error

            Logger.red(`error during event update ${e}`)

            handleEventServerError(e)
            eventHook.setLoading(false)
          })
      }
    })
  }

  const onEventSave = async (data: EventDoc) => {
    eventHook.setStatus(EventStatus.ACTIVE)
    await processEvent(data)
  }

  async function updateStatus(status: EventStatus) {
    eventHook.setStatus(status)
    await processEvent({ ...eventHook.getValues() })
  }

  const onEventDelete = async (status?: EventStatus) => {
    if (
      eventHook.taskType === TaskType.personalEvent &&
      isUiBlocked &&
      props.event.OwnerID === LocalStorage.get(LocalStorageKey.USER_ID)
    ) {
      eventHook.setAttendees(
        eventHook.attendees?.map((attendee) => {
          if (attendee.self)
            attendee.responseStatus = groupcalStatusToGoogle('3')
          return attendee
        }) ?? [],
        true
      )

      return await saveEventData(eventHook.getValues())
    }

    if (
      is24meApp() &&
      (props.event.Type === DocType.TASK ||
        props.event.Type === DocType.NOTE) &&
      (!props.event.Recurrence ||
        typeof props.event.Recurrence === 'string' ||
        Object.keys(props.event.Recurrence).length === 0)
    ) {
      LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
      updateEventOnServer(props.event, {
        Status:
          instanceStatus(props.event, props.instanceStart) ===
          EventStatus.COMPLETED
            ? EventStatus.DELETED
            : EventStatus.COMPLETED,
        SupplementaryGroupsIDs: props.event.SupplementaryGroupsIDs
      })
      props.onClose()
      closePopover()
      return
    }

    eventHook.setStatus(status ?? EventStatus.DELETED)

    deleteEvent(
      props.event,
      props.group,
      props.instanceStart,
      props.instanceEnd,
      () => {
        Logger.blue('EventPopup:Event deleted successfully')
        LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
        props.onClose()
        closePopover()
        eventHook.setLoading(false)
      },
      () => {
        eventHook.setLoading(true)
      },
      status,
      () => {
        eventHook.setStatus(instanceStatus(props.event, props.instanceStart))
      }
    )
  }

  function onApproveNoteText(text: string) {
    eventHook.setNotePendingText('')
    eventHook.addNote(text)
  }

  const removeTimeZone = () => {
    eventHook.setTimeZone(getDefaultTimezone())
  }

  function performRSVPChange(enabled: boolean) {
    eventHook.setRSVP(enabled ? '1' : '0')

    if (newEvent)
      Database.write(async () => {
        if (props.event.syncStatus === 'deleted') return
        ;(await localEventByLocalId(props.event.id ?? ''))?.update((local) => {
          local.RequestConfirmation = enabled ? '1' : '0'
        })
      })
  }

  const onRSVPChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (
      highestActiveTier(props.account) <
      featureToMinimumTierNeeded(TierFeatures.RSVP)
    ) {
      return
    }
    performRSVPChange(event.target.checked)
  }

  const handleCloseEventPopup = (simpleClose?: boolean) => {
    eventHook.setOpenDiscard(false)
    props.onClose(simpleClose, true)
  }

  const handleCloseRecurringSave = () => {
    setShowRecurrenceDialog(false)
  }

  function handleRecurringType(type: RECUR_SAVE_TYPE) {
    const data: EventDoc = {
      ...eventHook.getValues(),
      local_id: props.event.local_id
    }
    eventHook.setLoading(true)
    closePopover()
    calendarSync
      .syncEventWithThirdParty(
        props.instanceStart,
        props.instanceEnd,
        data,
        props.event as Model<EventDoc>,
        false,
        true,
        (e) => {
          Logger.red('error during event update', e)
          eventHook.setError(e)
        },
        type,
        'StartDate' in eventHook.dirtyFields ||
          'EndDate' in eventHook.dirtyFields
      )
      .then(() => {
        setShowRecurrenceDialog(false)
        eventHook.setLoading(false)
        props.onClose(false, true)
      })
  }

  const handleSaveRecurringEvent = async (type: RECUR_SAVE_TYPE) => {
    handleRecurringType(type)
  }

  const hideDiscardDialog = () => {
    eventHook.setOpenDiscard(false)
    props.setAwayClickTriggered(false)
  }

  const [openNoteDeatils, setOpenNoteDetails] = useState(
    props.event.Type === DocType.NOTE &&
      LocalStorage.get(LocalStorageKey.NOTE_DETAILS_ID) != props.event.id
  )

  /**
   * We need to store in a cache which note we are opened because user
   * might change a time so popup will recreate and we do not want to
   * show note details again
   */
  if (props.event.Type === DocType.NOTE) {
    LocalStorage.set(LocalStorageKey.NOTE_DETAILS_ID, props.event.id)
  }

  const handleCloseButtonClick = () => {
    Logger.orange('EventPopup:DirtyFields', eventHook.dirtyFields)
    if (
      Object.keys(eventHook.dirtyFields).length === 0 &&
      props.event._rev !== 'duplicated' &&
      LocalStorage.get(LocalStorageKey.PENDING_EVENT_DATA) === null
    ) {
      closePopover()
      props.onClose()
      if (props.event._id?.length === 0 && (calendar.ref as any).current) {
        try {
          ;(calendar.ref as any).current
            ?.getApi()
            .getEventById(props.fc_id)
            ?.remove()
          setTimeout(() => {
            RemoveTempEvents('Event close button')
          }, 50)
        } catch (e) {
          Logger.red("Can't remove temp event", e)
        }
      }
    } else {
      if (LocalStorage.get(LocalStorageKey.DRAGGING) !== '1') {
        eventHook.setOpenDiscard(true)
      }
    }
  }

  useEffect(() => {
    const keyEnter = async (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleCloseButtonClick()
      }
    }

    document.addEventListener('keydown', keyEnter as any)

    return () => {
      document.removeEventListener('keydown', keyEnter as any)
    }
  }, [])

  const onSubmit: SubmitHandler<EventDoc> = async (data) => {
    saveEventData(data)
  }

  const saveEventData = async (data: EventDoc) => {
    if (connection.isConnectionAvailable()) {
      try {
        await eventHook.applyPendingData().then(() => {
          return onEventSave(eventHook.getValues())
        })
      } catch (e) {
        handleEventServerError(e)
      }
    }
  }

  if (isGroupcalApp()) markEventAsReadIfNeeded(props.event)

  let readOnly = LocalStorage.get(LocalStorageKey.USER_ID)?.length === 0

  if (props.event.Organizer) {
    readOnly =
      props.event.Organizer.email !==
      removePrefix(props.group?.CalendarEmail ?? '')
  }

  const isActive = isUserActiveInGroup(
    props.group,
    LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
  )

  const [showUserBlockedDialog, setShowUserBlockedDialog] = useState(false)

  const hideUserBlocked = () => {
    setShowUserBlockedDialog(false)
  }

  const [userCannotAddEvents, setUserCanAddEvents] = useState(false)

  const showCanAddEventsDialog = () => {
    setUserCanAddEvents(true)
  }

  const hideCanAddEventsDialog = () => {
    setUserCanAddEvents(false)
  }

  const blockedOverlayClick = () => {
    if (props.group?.SyncProblem === '1') {
      onShowCalendarSync(true)
    } else if (isOutOfTier) {
      onShowOutOfTierDialog(true)
    } else if (!isUserCanOperateEvents(props.group, userId)) {
      showCanAddEventsDialog()
    } else {
      setShowUserBlockedDialog(true)
    }
  }

  const dismissError = () => {
    eventHook.setError('')
  }

  const isOutOfTier = isGroupOutOfTier(activeTier, props.group, props.account)

  let isUiBlocked: boolean = false
  const theirEventsOnlyCheck =
    props.event.OwnerID !== LocalStorage.get(LocalStorageKey.USER_ID) &&
    props.group?.GroupSettings?.IsAllParticipantsCanEditOnlyTheirEvents ===
      '1' &&
    !isUserAdminInGroup(
      props.group,
      LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
    )

  if (isGroupcalApp()) {
    isUiBlocked =
      isOutOfTier ||
      readOnly ||
      !isActive ||
      !isUserCanOperateEvents(props.group, userId) ||
      theirEventsOnlyCheck ||
      isEventBooked(props.event)
  } else {
    isUiBlocked = readOnly
  }

  Logger.blue(
    'EventPopup:isOutOfTier;isUiBlocked;newevent;readonly',
    isOutOfTier,
    isUiBlocked,
    newEvent,
    readOnly
  )

  const nonDefaultTimeZone =
    eventHook.getValues('TimeZoneNameID') !== undefined &&
    (eventHook.getValues('TimeZoneNameID')?.length ?? 0) > 0 &&
    eventHook.getValues('TimeZoneNameID') !== getDefaultTimezone()

  if (
    isConvertedGroup(props.group) &&
    props.event.Type !== DocType.TASK &&
    props.event.Type !== DocType.NOTE &&
    props.group?.OwnerID === LocalStorage.get(LocalStorageKey.USER_ID)
  ) {
    Logger.blue('EventPopup:isConvertedGroup', eventHook.getValues('GroupID'))
    Logger.blue('EventPopup:converted group', CurrentConvertedCalendars)
    const provider = groupIdToProvider(eventHook.getValues('GroupID') ?? '')
    Logger.blue('EventPopup:provider', provider)
    Logger.blue('EventPopup:PersonalOwnerId', props.event.PersonalOwnerId)

    if (props.group?.SyncProblem === '1' || isOutOfTier) {
      isUiBlocked = true
    } else {
      if (
        provider == ProviderType.GOOGLE ||
        provider === ProviderType.OUTLOOK
      ) {
        const calendar = CurrentConvertedCalendars.find(
          (calendar) =>
            calendar.id === removePrefix(props.event.ThirdPartyID ?? '')
        )
        Logger.blue('EventPopup:found calendar', calendar)
        isUiBlocked =
          props.event.PersonalOwnerId !== calendar?.primaryCalendarEmail ||
          calendar?.canEdit === false
      }
    }
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  const [showColorPopup, setShowColorPopup] = useState(false)

  if (props.showSmallUI) {
    const hideEventDetails = () => {
      closePopover()
      props.onClose()
    }

    return (
      <SmallEventDialog
        event={props.event}
        eventHook={eventHook}
        isUiBlocked={isUiBlocked}
        timeZoneOpen={timeZoneOpen}
        setTimeZoneOpen={setTimeZoneOpen}
        removeTimeZone={removeTimeZone}
        nonDefaultTimeZone={nonDefaultTimeZone}
        onClose={hideEventDetails}
      />
    )
  }

  function providePlaceholderByType(
    Type: DocType | undefined
  ): string | undefined {
    if (Type === DocType.TASK) return `${i18n.t('addTitleTask')}`

    if (Type === DocType.NOTE) return `${i18n.t('addTitleNote')}`

    return `${i18n.t('addTitle')}`
  }

  function statusByEvent(event?: Model<EventDoc> | EventDoc): EventStatus {
    if (event?.Type === DocType.TASK || event?.Type === DocType.NOTE) {
      if (
        instanceStatus(props.event, props.instanceStart) === EventStatus.ACTIVE
      ) {
        return EventStatus.COMPLETED
      }
    }

    return EventStatus.DELETED
  }

  function deleteTitleByEvent(event?: Model<EventDoc> | EventDoc): string {
    if (event?.Type === DocType.TASK || event?.Type === DocType.NOTE) {
      if (
        instanceStatus(props.event, props.instanceStart) === EventStatus.ACTIVE
      ) {
        return t('complete')
      }

      if (
        instanceStatus(props.event, props.instanceStart) ===
        EventStatus.COMPLETED
      ) {
        return t('archive')
      }
    }

    return t('delete')
  }

  function deleteIconByEvent(event?: Model<EventDoc> | EventDoc): ReactNode {
    if (event?.Type === DocType.TASK || event?.Type === DocType.NOTE) {
      if (
        instanceStatus(props.event, props.instanceStart) === EventStatus.ACTIVE
      ) {
        return <CompleteIcon />
      }

      if (
        instanceStatus(props.event, props.instanceStart) ===
        EventStatus.COMPLETED
      ) {
        return <ArchiveIcon />
      }
    }

    return <DeleteIcon />
  }

  function buildTimeZoneRow(value: string): ReactNode {
    let zonedStart = dayjs(Number(eventHook.getValues('StartDate')) * 1000).tz(
      getDefaultTimezone()
    )
    let zonedEnd = dayjs(Number(eventHook.getValues('EndDate')) * 1000).tz(
      getDefaultTimezone()
    )

    if (eventHook.getValues('AllDay') === '1') {
      zonedStart = dayjs(Number(eventHook.getValues('StartDate')) * 1000)
      zonedEnd = dayjs(Number(eventHook.getValues('EndDate')) * 1000)
    }

    let yourTimeZoneTime = ''
    const zonedStartDay = zonedStart.format('MMMM DD')
    const zonedEndDay = zonedEnd.format('MMMM DD')

    if (eventHook.timeZone !== getDefaultTimezone()) {
      yourTimeZoneTime = `(${t('yourTimeZone', {
        time: `${zonedStartDay}, ${dateToTimeString(
          zonedStart.toDate(),
          true
        )} - ${
          zonedEndDay !== zonedStartDay ? `${zonedEndDay}, ` : ''
        } ${dateToTimeString(zonedEnd.toDate(), true)}`
      })})`
    }

    return (
      <Grid container direction={'column'} gap={1}>
        {value}
        <MiscText
          fontFamily={'NotoSans'}
          fontWeight={'400 !important'}
          marginLeft={i18n.dir() === 'ltr' ? '6px' : undefined}
          marginRight={i18n.dir() === 'ltr' ? undefined : '6px'}
          color={'rgba(0, 0, 0, 0.5)'}
        >
          {yourTimeZoneTime}
        </MiscText>
      </Grid>
    )
  }

  function setRegularEventColor(color: string) {
    const metaData = addColorToMetaData(props.event, color)
    if (!eventHook.notes || eventHook.notes.length === 0) {
      eventHook.addNote(appendNoteWithMetaData('', metaData))
    } else {
      eventHook.setNotes([
        {
          ...eventHook.notes[0],
          Note: appendNoteWithMetaData(
            clearNote(eventHook.notes[0].Note),
            metaData
          )
        }
      ])
    }

    Logger.pink('Event:', eventHook.getValues('Notes'))

    eventHook.setSelectedColor(color)
  }

  const [showOutlookReminderDialog, setShowOutlookReminderDialog] =
    useState(false)

  useEffect(() => {
    setTimeout(() => {
      if (isContextMenuOpen) {
        handleCloseButtonClick()
      }
    }, 250)
  }, [isContextMenuOpen])

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={() => {
        if (
          LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) === '1' ||
          LocalStorage.get(LocalStorageKey.DRAGGING) === '1'
        ) {
          return
        }
        setTimeout(() => {
          if (LocalStorage.get(LocalStorageKey.DRAGGING) !== '1') {
            handleCloseButtonClick()
          }
        }, 500)
      }}
    >
      <Stack
        id="event-popup-content-box"
        sx={{
          minWidth: '450px',
          maxWidth: '700px',
          borderRadius: '24px',
          overflow: 'hidden'
        }}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Controller
          name="Notes"
          control={eventHook.control}
          defaultValue={props.event.Notes}
          render={({ field }) => {
            const coverImageNote = getCoverImageNote(field.value)
            const hasCoverImage = !!coverImageNote && needShowCoverImage()

            // Keep track of whether we're animating out so styles persist
            const [showCoverStyles, setShowCoverStyles] =
              useState(hasCoverImage)
            const lastCoverNotesRef = useRef(field.value)

            // When cover image appears, update immediately
            // When it disappears, delay style removal until fade completes
            useEffect(() => {
              if (hasCoverImage) {
                lastCoverNotesRef.current = field.value
                setShowCoverStyles(true)
              }
            }, [hasCoverImage, field.value])

            const handleFadeExited = () => {
              setShowCoverStyles(false)
            }

            const popupContainerRef = useRef<HTMLDivElement | null>(null)
            const [isScrollEnabled, setIsScrollEnabled] = useState(false)

            useEffect(() => {
              const updateScrollState = () => {
                const container = popupContainerRef.current
                if (!container) return

                const currentHeight = container.getBoundingClientRect().height
                const maxAllowedHeight = Math.min(
                  window.innerHeight * 0.9,
                  1000
                )
                setIsScrollEnabled(currentHeight >= maxAllowedHeight - 1)
              }

              updateScrollState()

              const container = popupContainerRef.current
              if (!container) return

              const observer = new ResizeObserver(() => {
                updateScrollState()
              })

              observer.observe(container)
              window.addEventListener('resize', updateScrollState)

              return () => {
                observer.disconnect()
                window.removeEventListener('resize', updateScrollState)
              }
            }, [showCoverStyles])

            // Use showCoverStyles for container styling (persists during fade-out)
            // Use hasCoverImage for the Fade `in` prop (triggers animation)

            // Show gallery button for shared events on non-converted calendars
            const showGalleryButton =
              !isCurrentGroupIsThirdPartyCalendar &&
              !isConvertedGroupId(eventHook.getValues('GroupID')) &&
              !isUiBlocked &&
              needShowCoverImage()

            return (
              <Box
                ref={popupContainerRef}
                sx={{
                  display: 'grid',
                  gridTemplateRows: 'auto 1fr',
                  overflow: 'hidden',
                  minHeight: 550,
                  maxHeight: 'min(90vh, 1000px)',
                  position: 'relative'
                }}
              >
                {eventHook.loading && (
                  <LoadingContainer
                    loading={eventHook.loading ? 1 : 0}
                    dontShowSpinner
                  />
                )}
                <Styled.EventPopupHead
                  sx={{
                    position: 'relative',
                    ...(showCoverStyles
                      ? {
                          minHeight: '200px',
                          backgroundColor: 'transparent',
                          overflow: 'hidden',
                          borderRadius: '24px 24px 0 0',
                          transition:
                            'min-height 0.4s ease, background-color 0.4s ease'
                        }
                      : {
                          transition:
                            'min-height 0.4s ease, background-color 0.4s ease'
                        })
                  }}
                >
                  <Fade
                    in={hasCoverImage}
                    timeout={400}
                    unmountOnExit
                    onExited={handleFadeExited}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 0
                      }}
                    >
                      <EventCoverImage
                        notes={
                          hasCoverImage
                            ? field.value
                            : lastCoverNotesRef.current
                        }
                      />
                    </Box>
                  </Fade>
                  <Grid
                    item
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    wrap={'nowrap'}
                    sx={{ position: 'relative', zIndex: 1, marginTop: '8px' }}
                  >
                    <GroupcalTooltip title={t('close')}>
                      <Styled.PopupCloseButton
                        id="event-popup-close-button"
                        type={'button'}
                        size="sm"
                        onClick={() => {
                          handleCloseButtonClick()
                        }}
                      >
                        <CloseIcon
                          style={
                            showCoverStyles ? { color: 'white' } : undefined
                          }
                        />
                      </Styled.PopupCloseButton>
                    </GroupcalTooltip>
                    <Grid
                      container
                      wrap={'nowrap'}
                      direction={'row'}
                      mt={0.5}
                      columnGap={2}
                      justifyContent={'end'}
                      mr={
                        i18n.dir() === 'ltr' && showCoverStyles
                          ? '5px'
                          : undefined
                      }
                      ml={
                        i18n.dir() === 'rtl' && showCoverStyles
                          ? '5px'
                          : undefined
                      }
                    >
                      {newEvent || readOnly ? (
                        <></>
                      ) : (
                        <EventsActionsMenu
                          onClose={props.onClose}
                          instanceEnd={props.instanceEnd}
                          instanceStart={props.instanceStart}
                          disabled={isUiBlocked}
                          event={props.event}
                          eventHook={eventHook}
                          closePopup={handleCloseEventPopup}
                          updateStatus={updateStatus}
                        />
                      )}
                      {newEvent || readOnly ? (
                        <></>
                      ) : (
                        <Button
                          id="delete-event-button"
                          tootltip={`${deleteTitleByEvent(props.event)}`}
                          onClick={() => {
                            onEventDelete(statusByEvent(props.event))
                          }}
                          type="button"
                          size="icon"
                        >
                          {deleteIconByEvent(props.event)}
                        </Button>
                      )}
                      <Controller
                        name="Text"
                        control={eventHook.control}
                        defaultValue={props.event.Text}
                        render={({ field }) => (
                          <Button
                            id="save-event-button"
                            onClick={() => {
                              saveEventData(eventHook.getValues())
                            }}
                            tootltip="add"
                            type="submit"
                            size="xs"
                            disabled={field.value?.trim().length === 0}
                          >
                            {newEvent
                              ? props.event._rev === 'duplicated'
                                ? `${t('save')}`
                                : `${t('add')}`
                              : `${t('save')}`}
                            {eventHook.loading && (
                              <LoadingSpinner
                                loading={eventHook.loading ? 1 : 0}
                                sx={{
                                  top: -4,
                                  right: 0,
                                  left: 0,
                                  margin: 'auto'
                                }}
                              />
                            )}
                          </Button>
                        )}
                      />
                    </Grid>
                  </Grid>
                  {is24meApp() &&
                  newEvent &&
                  appUiContext.uiType.value === AppUIType.calendars ? (
                    <TypeSegment eventHook={eventHook} />
                  ) : (
                    <></>
                  )}
                  <Controller
                    name="Type"
                    control={eventHook.control}
                    defaultValue={props.event.Type}
                    render={({ field }) => {
                      const type = field.value
                      return (
                        <Controller
                          name="Text"
                          control={eventHook.control}
                          defaultValue={props.event.Text}
                          render={({ field }) => (
                            <Styled.EventPopupInputContainer
                              sx={{
                                position: 'relative',
                                zIndex: 1,
                                alignItems: isConvertedGroupId(
                                  eventHook.getValues('GroupID')
                                )
                                  ? 'center'
                                  : 'end'
                              }}
                            >
                              <TextField
                                inputRef={titleInputRef}
                                id="event-title-input"
                                sx={{
                                  width: '100%',
                                  paddingLeft: '4px',
                                  paddingRight: '4px',
                                  marginLeft:
                                    i18n.dir() === 'ltr' ? '-4px' : undefined,
                                  marginRight:
                                    i18n.dir() === 'ltr' ? undefined : '-4px',
                                  zIndex: 2000,
                                  '&:hover': {
                                    borderRadius: '8px',
                                    backgroundColor: showCoverStyles
                                      ? 'transparent'
                                      : theme.palette.background.paper
                                  }
                                }}
                                onKeyDown={handleKeyPress}
                                multiline
                                autoFocus={newEvent}
                                maxRows={14}
                                value={
                                  isEventBooked(props.event)
                                    ? provideEventTitle(props.event)
                                    : field.value
                                }
                                className={classes.root}
                                placeholder={providePlaceholderByType(type)}
                                onChange={(
                                  event: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  eventHook.setName(event.target.value)
                                  eventHook.onTitleSet(true)
                                }}
                                variant="standard"
                                InputProps={{
                                  style: {
                                    textDecoration:
                                      instanceStatus(
                                        props.event,
                                        props.instanceStart
                                      ) === EventStatus.COMPLETED
                                        ? 'line-through'
                                        : 'none',
                                    fontSize: '1.4rem',
                                    fontWeight: 600,
                                    pointerEvents: isUiBlocked ? 'none' : 'all',
                                    borderBottom: 'none',
                                    color: showCoverStyles ? 'white' : undefined
                                  }
                                }}
                              />
                              {is24meApp() &&
                                (eventHook.getValues('Type') === DocType.TASK ||
                                  eventHook.getValues('Type') ===
                                    DocType.NOTE) && (
                                  <Controller
                                    name="Priority"
                                    control={eventHook.control}
                                    defaultValue={props.event.Priority}
                                    render={({ field }) => (
                                      <div style={{}}>
                                        <IconButton
                                          onClick={() => {
                                            field.onChange(
                                              field.value === '2' ? '1' : '2'
                                            )
                                          }}
                                          size="sm"
                                        >
                                          <PriorityIcon
                                            style={{
                                              color:
                                                field.value === '2'
                                                  ? 'red'
                                                  : undefined
                                            }}
                                          />
                                        </IconButton>
                                      </div>
                                    )}
                                  />
                                )}
                              <BlockOverlay
                                id="title-block-overlay"
                                blockedOverlayLeftOffset={
                                  i18n.dir() === 'rtl' ? -12 : -4
                                }
                                blockedOverlayRightOffset={
                                  i18n.dir() === 'rtl' ? -4 : -12
                                }
                                blockedOverlayTopOffset={-2}
                                blockedOverlayBottomOffset={-2}
                                zIndex={10000}
                                isUiBlocked={isUiBlocked}
                                blockedOverlayClick={blockedOverlayClick}
                              />
                              {showGalleryButton && (
                                <GalleryButton eventHook={eventHook} />
                              )}
                              <Controller
                                name="TaskType"
                                control={eventHook.control}
                                defaultValue={props.event.TaskType}
                                render={({ field }) => (
                                  <div style={{}}>
                                    {field.value === TaskType.personalEvent && (
                                      <Box
                                        id="event-color-popup-button"
                                        sx={{
                                          right: i18n.dir() === 'ltr' ? 4 : 0,
                                          left: i18n.dir() === 'ltr' ? 0 : 4,
                                          mr: i18n.dir() === 'ltr' ? '9px' : 0,
                                          ml: i18n.dir() === 'ltr' ? 0 : '9px'
                                        }}
                                      >
                                        <Controller
                                          name="TaskType"
                                          control={eventHook.control}
                                          defaultValue={props.event.TaskType}
                                          render={({ field }) => {
                                            return (
                                              <ColorsPopup
                                                open={showColorPopup}
                                                setOpen={setShowColorPopup}
                                                color={eventHook.selectedColor}
                                                setColor={setRegularEventColor}
                                              />
                                            )
                                          }}
                                        />
                                      </Box>
                                    )}
                                  </div>
                                )}
                              />
                            </Styled.EventPopupInputContainer>
                          )}
                        />
                      )
                    }}
                  />
                </Styled.EventPopupHead>

                <Box
                  sx={{
                    overflowY: isScrollEnabled ? 'auto' : 'hidden',
                    minHeight: 0,
                    overflowX: 'hidden'
                  }}
                >
                  <ConferenceSection {...props} />
                  <Box height={'12px'} />
                  {isGroupcalApp() || eventHook.type === DocType.EVENT ? (
                    <Controller
                      name="GroupID"
                      control={eventHook.control}
                      defaultValue={props.event.GroupID}
                      render={({ field }) => {
                        const groupID = field.value ?? ''
                        return (
                          <Controller
                            name="ThirdPartyID"
                            control={eventHook.control}
                            defaultValue={props.event.ThirdPartyID}
                            render={({ field }) => {
                              const thirdPartyID = field.value ?? ''
                              return (
                                <Controller
                                  name="SupplementaryGroupsIDs"
                                  control={eventHook.control}
                                  defaultValue={
                                    props.event.SupplementaryGroupsIDs
                                  }
                                  render={({ field }) => {
                                    return (
                                      <CalendarSection
                                        thirdParty={thirdPartyID}
                                        setType={eventHook.setType}
                                        selectedGroupId={groupID}
                                        setGroupID={eventHook.setGroupID}
                                        setThirdPartyId={
                                          eventHook.setThirdPartyId
                                        }
                                        isUiBlocked={isUiBlocked}
                                        blockedOverlayClick={
                                          blockedOverlayClick
                                        }
                                        eventHook={eventHook}
                                        SupplementaryGroupsIDs={field.value}
                                        setRegularEventColor={
                                          setRegularEventColor
                                        }
                                        {...props}
                                      />
                                    )
                                  }}
                                />
                              )
                            }}
                          />
                        )
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  <PopupSection
                    isUiBlocked={isUiBlocked}
                    blockedOverlayClick={blockedOverlayClick}
                    title={`${i18n.t('time')}`}
                  >
                    <Controller
                      name="someday"
                      control={eventHook.control}
                      defaultValue={props.event.someday}
                      render={({ field }) => (
                        <Box
                          display={'flex'}
                          flexDirection={'column'}
                          width={'100%'}
                        >
                          <Controller
                            name="EndDate"
                            control={eventHook.control}
                            defaultValue={props.event.EndDate}
                            render={({ field }) => (
                              <StartEndDateRows
                                initiallyExpanded={false}
                                eventHook={eventHook}
                                event={props.event}
                                timeZoneOpen={timeZoneOpen}
                                setTimeZoneOpen={setTimeZoneOpen}
                                removeTimeZone={removeTimeZone}
                                nonDefaultTimeZone={nonDefaultTimeZone}
                              />
                            )}
                          />

                          {nonDefaultTimeZone &&
                            eventHook.getValues('AllDay') !== '1' &&
                            eventHook.getValues('someday') !== '1' && (
                              <PopupSectionRow
                                onlyTitle
                                icon={<GlobeIcon />}
                                title={buildTimeZoneRow('')}
                              />
                            )}
                          {field.value === '1' ? (
                            <></>
                          ) : (
                            <Controller
                              name="AllDay"
                              control={eventHook.control}
                              defaultValue={props.event.AllDay}
                              render={({ field }) => (
                                <AllDayRow
                                  value={field.value ?? '0'}
                                  field={field}
                                  setAllDay={(allday) => {
                                    eventHook.setAllDay(allday)
                                  }}
                                />
                              )}
                            />
                          )}
                        </Box>
                      )}
                    />

                    <Controller
                      name="someday"
                      control={eventHook.control}
                      defaultValue={props.event.someday}
                      render={({ field }) =>
                        field.value === '1' ? (
                          <></>
                        ) : (
                          <Controller
                            name="Recurrence"
                            control={eventHook.control}
                            defaultValue={props.event.Recurrence}
                            render={({ field }) => (
                              <EventRecurrenceComponent
                                userSettings={props.userSettings}
                                eventHook={eventHook}
                                recurrence={field.value}
                                setEventRecurrence={eventHook.setRecurrence}
                              />
                            )}
                          />
                        )
                      }
                    />
                  </PopupSection>
                  <PopupSection
                    title={`${t('location')}`}
                    contentZIndex={
                      (props.event.Location?.Address?.length ?? 0) !== 0 ? 3 : 1
                    }
                    blockedOverlayClick={blockedOverlayClick}
                    isUiBlocked={isUiBlocked}
                  >
                    <Controller
                      name="Location"
                      control={eventHook.control}
                      defaultValue={props.event.Location}
                      render={({ field }) => (
                        <EventLocationRow
                          isUiBlocked={isUiBlocked}
                          disallowEdit={isUiBlocked}
                          eventHook={eventHook}
                          setLocation={eventHook.setLocation}
                          eventLocation={field.value}
                        />
                      )}
                    />
                  </PopupSection>
                  {!isEventBooked(props.event) && (
                    <PopupSection title={`${t('reminders')}`}>
                      <Controller
                        name="Reminder"
                        control={eventHook.control}
                        defaultValue={props.event.Reminder}
                        render={({ field }) => {
                          Logger.pink('Reminders:Draw', field.value)
                          return field.value ? (
                            <RemindersList
                              setReminders={eventHook.setReminders}
                              event={eventHook.getValues()}
                              reminders={
                                typeof field.value !== 'string'
                                  ? (field.value ?? [])
                                  : []
                              }
                            />
                          ) : (
                            <></>
                          )
                        }}
                      />
                      <AddReminderPopup
                        setOpen={eventHook.setOpenAddReminder}
                        open={eventHook.openAddReminder}
                        reminders={eventHook.reminders || []}
                        setReminders={eventHook.setReminders}
                        event={eventHook.getValues()}
                      >
                        <div>
                          <PopupSectionRow
                            action={() => {
                              const provider = groupIdToProvider(
                                eventHook.getValues('GroupID') ?? ''
                              )
                              Logger.group('Reminder Provider', provider)

                              if (
                                provider === ProviderType.OUTLOOK &&
                                eventHook.getValues('Reminder')?.length === 1
                              ) {
                                // show explanation dialog for outlook when there are 1 reminder already
                                setShowOutlookReminderDialog(true)
                                return
                              }

                              eventHook.setOpenAddReminder(true)
                            }}
                            actionBg
                            titleColor={theme.palette.input.placeholder}
                            icon={
                              <Box marginLeft={'2px'}>
                                <PlusIcon />
                              </Box>
                            }
                            valuePlaceholder
                            actionId="add-reminder-button"
                            title={t('addReminder')}
                            value=""
                          />
                        </div>
                      </AddReminderPopup>
                    </PopupSection>
                  )}

                  {isCurrentGroupIsThirdPartyCalendar || isGroupcalApp() ? (
                    <PopupSection
                      title={`${t(
                        isCurrentGroupIsThirdPartyCalendar
                          ? 'participants'
                          : 'members'
                      )}`}
                      isUiBlocked={isUiBlocked}
                      blockedOverlayClick={blockedOverlayClick}
                    >
                      {isCurrentGroupIsThirdPartyCalendar ? (
                        <Controller
                          name="attendees"
                          control={eventHook.control}
                          defaultValue={props.event.attendees}
                          render={({ field }) =>
                            field.value ? (
                              <ParticipantsList
                                eventDoc={props.event}
                                eventHook={eventHook}
                                participants={field.value}
                                showExpanded={isUiBlocked}
                                group={props.group}
                              />
                            ) : (
                              <></>
                            )
                          }
                        />
                      ) : (
                        <Box display={'flex'} flexDirection={'column'}>
                          <PopupSectionRow
                            title={t('requestToConfirmParticipation')}
                            tierFeature={TierFeatures.RSVP}
                            cursor="default"
                            action={() => {
                              performRSVPChange(true)
                            }}
                            neededTier={
                              isOwnerForGroup(props.group)
                                ? featureToMinimumTierNeeded(TierFeatures.RSVP)
                                : Tier.FREE
                            }
                            value={
                              <Switch
                                onChange={onRSVPChange}
                                checked={eventHook.RSVP === '1'}
                              />
                            }
                          />
                          <Controller
                            control={eventHook.control}
                            name="GroupID"
                            defaultValue={props.group?._id ?? ''}
                            render={({ field }) => {
                              const selectedGroup = field.value
                              return (
                                <Controller
                                  name="OwnerID"
                                  control={eventHook.control}
                                  defaultValue={props.event.OwnerID}
                                  render={({ field }) => (
                                    <MembersList
                                      setLoading={eventHook.setLoading}
                                      event={props.event}
                                      group={props.group}
                                      groupId={selectedGroup}
                                      withoutActions={false}
                                      eventHook={eventHook}
                                      actionsOnEvent
                                      localParticipants={[]}
                                    />
                                  )}
                                />
                              )
                            }}
                          ></Controller>
                        </Box>
                      )}
                    </PopupSection>
                  ) : (
                    <></>
                  )}
                  <Controller
                    name="Type"
                    control={eventHook.control}
                    defaultValue={props.event.Type}
                    render={({ field }) =>
                      field.value ? (
                        <NotesSection
                          isCurrentGroupIsGoogleCalendar={
                            isCurrentGroupIsThirdPartyCalendar
                          }
                          eventHook={eventHook}
                          event={props.event}
                          onApproveNoteText={onApproveNoteText}
                          openNoteDetails={openNoteDeatils}
                          setOpenNoteDetails={setOpenNoteDetails}
                          isUiBlocked={isUiBlocked}
                          blockedOverlayClick={blockedOverlayClick}
                        />
                      ) : (
                        <></>
                      )
                    }
                  />

                  {(eventHook.type === DocType.TASK ||
                    eventHook.type === DocType.NOTE) && (
                    <Controller
                      name="Label"
                      control={eventHook.control}
                      defaultValue={props.event.Label}
                      render={({ field }) => (
                        <LabelsSection
                          labels={field.value}
                          setLabels={eventHook.setLabels}
                          setLoading={eventHook.setLoading}
                          event={props.event}
                        />
                      )}
                    />
                  )}
                </Box>

                {eventHook.openDiscard && (
                  <ConfirmationDialog
                    title={`${t('areYouSureCancel')}`}
                    content={''}
                    rightButton={`${t('discard')}`}
                    leftButton={`${t('cancel')}`}
                    leftButtonColor={'black'}
                    rightButtonColor={APP_COLOR}
                    handleLeftButton={hideDiscardDialog}
                    open={true}
                    handleClose={() => {
                      if (openNoteDeatils) {
                        setOpenNoteDetails(false)
                        hideDiscardDialog()
                      } else {
                        LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
                        LocalStorage.remove(LocalStorageKey.PENDING_EVENT_DATA)
                        handleCloseEventPopup()
                        closePopover()
                        RemoveTempEvents('Event content dialog close')
                      }
                    }}
                  />
                )}
                {showRecurrenceDialog && (
                  <RecurrentActionDialog
                    item={props.event}
                    open={showRecurrenceDialog}
                    handleClose={handleCloseRecurringSave}
                    handleSaveRecurringEvent={handleSaveRecurringEvent}
                    default={isUiBlocked ? RECUR_SAVE_TYPE.ALL : undefined}
                    disableOthers={isUiBlocked}
                  />
                )}
                {showUserBlockedDialog && (
                  <ConfirmationDialog
                    rightButtonHidden
                    title={
                      isConvertedGroup(props.group)
                        ? t('readyOnlyConverted')
                        : theirEventsOnlyCheck
                          ? t('thisCalendarAllows')
                          : t('youDontHavePermissions')
                    }
                    content={''}
                    handleLeftButton={hideUserBlocked}
                    handleClose={hideUserBlocked}
                    open={showUserBlockedDialog}
                  />
                )}
                {eventHook.error && eventHook.error.length > 0 && (
                  <ConfirmationDialog
                    rightButtonHidden
                    title={t('cantDoThat')}
                    content={eventHook.error}
                    leftButtonColor={APP_COLOR}
                    leftButton={`${t('ok')}`}
                    handleLeftButton={dismissError}
                    handleClose={dismissError}
                    open={eventHook.error.length > 0}
                  />
                )}
                {userCannotAddEvents && (
                  <ConfirmationDialog
                    rightButtonHidden
                    title={t('cantDoThat')}
                    content={t('thisEventPartOf')}
                    handleLeftButton={hideCanAddEventsDialog}
                    handleClose={hideCanAddEventsDialog}
                    open={userCannotAddEvents}
                  />
                )}
                {showOutOfTierDialog && (
                  <OutOfTierDialog
                    account={props.account}
                    flow={newEvent ? BlockedFlow.addItem : BlockedFlow.editItem}
                    group={props.group}
                    setOpen={onShowOutOfTierDialog}
                    opened={showOutOfTierDialog}
                  />
                )}
                {showOutOfTierDialog && (
                  <OutOfTierDialog
                    group={props.group}
                    setOpen={onShowOutOfTierDialog}
                    opened={showOutOfTierDialog}
                  />
                )}
                {showCalendarSync && (
                  <ResyncCalendarDialog
                    isOpen={showCalendarSync}
                    setOpen={onShowCalendarSync}
                    group={props.group}
                  />
                )}
                {showOutlookReminderDialog && (
                  <ConfirmationDialog
                    title={t('outlookReminder')}
                    content={''}
                    leftButtonHidden
                    handleClose={() => setShowOutlookReminderDialog(false)}
                    open={showOutlookReminderDialog}
                  />
                )}
                {shouldShowGoingBar(props.event) ? (
                  <div
                    style={{
                      marginLeft: '16px',
                      marginRight: '16px',
                      paddingBottom: '16px',
                      position: 'sticky',
                      bottom: 0,
                      zIndex: 13
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'rgb(229, 229, 229)',
                        borderRadius: '20px',
                        width: '100%',
                        height: '100%',
                        padding: '8px',
                        overflow: 'hidden'
                      }}
                    >
                      <PopupSectionRow
                        title={
                          <Typography
                            fontWeight={500}
                          >{`${t('going')}`}</Typography>
                        }
                        value={
                          <GoingBar
                            attendees={eventHook.attendees}
                            setLoading={eventHook.setLoading}
                            event={props.event}
                            status={eventHook.participantsStatus}
                            setStatus={eventHook.setParticipantStatus}
                            setAttendees={eventHook.setAttendees}
                          />
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <Box width={'100%'} height={2} />
                )}
              </Box>
            )
          }}
        />
      </Stack>
    </ClickAwayListener>
  )
}

function ConferenceSection(props: ContentProps) {
  const conferenceLink = props.event.ConferenceData?.entryPoints?.find(
    (e) => e.entryPointType === 'video'
  )?.uri
  const copyMeetTextToClip = async () => {
    const phonePoint = props.event.ConferenceData?.entryPoints?.find(
      (point) => point.entryPointType === 'phone'
    )
    const morePoint = props.event.ConferenceData?.entryPoints?.find(
      (point) => point.entryPointType === 'more'
    )

    let text =
      `${props.event.Text}` +
      `\n${dayjs(Number(props.event.StartDate) * 1000).format(
        'dddd, MMMM, DD · HH:mm - '
      )}${dayjs(Number(props.event.EndDate) * 1000).format('HH:mm')}` +
      `\n${t('appJoining', {
        appName: props.event.ConferenceData?.conferenceSolution?.name
      })}\n${t('videoCallLink')}: ${conferenceLink}`

    if (phonePoint?.pin) {
      text += `\n${phonePoint?.uri ?? ''} PIN: ${phonePoint.pin}`
    }

    if (phonePoint?.passcode) {
      text += `\n${phonePoint?.uri ?? ''} PASSCODE: ${phonePoint.passcode}`
    }

    if (morePoint) {
      text += `\n${t('forMoreDial')}: ${morePoint?.uri}`
    }
    await navigator.clipboard.writeText(text)
  }

  const openGoogleMeet = () => {
    window.open(conferenceLink, '_blank')
  }

  if (
    !props.event.ConferenceData ||
    (typeof props.event.ConferenceData === 'string' &&
      props.event.ConferenceData === 'null')
  )
    return <></>

  return (
    <PopupSection>
      {props.event.ConferenceData && (
        <PopupSectionRow
          title={
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                color: APP_COLOR
              }}
              href={conferenceLink}
            >{`${t('joinWithApp', {
              appName: props.event.ConferenceData?.conferenceSolution?.name
            })}`}</a>
          }
          onlyTitle
          iconClass="icon-big"
          icon={
            <span onClick={openGoogleMeet}>
              <img
                width={24}
                height={24}
                src={props.event.ConferenceData?.conferenceSolution?.iconUri}
              />
            </span>
          }
          value={
            <IconButton
              tooltip={`${t('copyConferenceInfo')}`}
              size="xs"
              onClick={copyMeetTextToClip}
            >
              <CopyPaste width={18} height={18} />
            </IconButton>
          }
        />
      )}
    </PopupSection>
  )
}

interface EventPopupProps {
  userSettings?: Model<UserSettingsDoc> | UserSettingsDoc
  account?: Model<AccountDoc> | AccountDoc
  event?: Model<EventDoc> | EventDoc
  group?: Model<GroupDoc> | GroupDoc
  children: ReactNode
  open: boolean
  setOpen: (b: boolean) => void
  instanceStart?: number
  instanceEnd?: number
  onClose?: () => void
  fc_id?: string
  awayClickTriggered: boolean
  setAwayClickTriggered: (b: boolean) => void
  embedMode?: boolean
}

export default function EventPopup(props: EventPopupProps) {
  const closeEvent = (simpleClose?: boolean, forceClose?: boolean) => {
    if (
      LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) !== '1' ||
      forceClose
    ) {
      Logger.blue('close called')
      const scrollers = document.querySelectorAll('.fc-scroller')
      scrollers.forEach((scroller) => {
        ;(scroller as any).style.overflow = 'auto'
      })
      LocalStorage.remove(LocalStorageKey.NOTE_DETAILS_ID)

      props.setOpen(false)
      if (props.onClose) {
        props.onClose()
      }

      if (simpleClose) {
        return
      }
    }
  }
  const showSmallUI =
    props.embedMode ||
    LocalStorage.get(LocalStorageKey.USER_ID) === null ||
    LocalStorage.get(LocalStorageKey.USER_ID)?.length === 0

  return (
    <EventPopupStyled.EventDetailsPopup
      sx={{ opacity: showSmallUI ? 0 : 1 }}
      open={props.open || false}
      onHide={() => {
        setTimeout(() => {
          LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
          LocalStorage.remove(LocalStorageKey.MORE_EVENTS_OPENED)
          LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
        }, 260)
      }}
      padding={0}
      content={
        (props.userSettings ?? {}) &&
        props.event && (
          <EventPopupContent
            {...props}
            event={props.event!}
            group={props.group}
            showSmallUI={showSmallUI}
            userSettings={props.userSettings!}
            account={props.account!}
            onClose={closeEvent}
            instanceStart={
              props.instanceStart ?? Number(props.event.StartDate) * 1000
            }
            instanceEnd={
              props.instanceEnd ?? Number(props.event.EndDate) * 1000
            }
            fc_id={props.fc_id ?? ''}
          />
        )
      }
    >
      {props.children}
    </EventPopupStyled.EventDetailsPopup>
  )
}

async function markEventAsReadIfNeeded(event?: Model<EventDoc> | EventDoc) {
  if (
    !event ||
    isTrulyEmpty(event._id) ||
    isTrulyEmpty(event._rev) ||
    !LocalStorage.get(LocalStorageKey.USER_ID) ||
    (!isTrulyEmpty(event.local_id) &&
      event.OwnerID === LocalStorage.get(LocalStorageKey.USER_ID))
  )
    return

  const currentStatus =
    event.ParticipantsStatus?.[LocalStorage.get(LocalStorageKey.USER_ID) ?? '']

  if (
    event._id &&
    currentStatus?.ParticipantDeliveryStatus !==
      ParticipantDeliveryStatusType.READ
  ) {
    const readBody: UpdateParticipantStatusBody = {
      _id: event._id,
      ParticipantsStatus: {
        ...currentStatus,
        ParticipantDeliveryStatus: ParticipantDeliveryStatusType.READ
      },
      DeviceChangeID: LocalStorage.get(LocalStorageKey.DEVICE_ID) ?? ''
    }

    await updateParticipantStatus([readBody])
  }
}

export function parseErrorToMessage(
  error: AxiosError | any,
  eventId?: string
): string {
  const httpCode = error.response?.status

  if (httpCode === 403) {
    /**
     * we have specific cases when server return 403, but we should not retry the request, such as:
     * out of tier, user blocked from adding/editing events etc
     *
     */
    const code = (error.response?.data as unknown as any)['code']
    const isByRSVP = (error.response?.data as unknown as any)['byEventsRSVP']
    const isByEventOwnership = (error.response?.data as unknown as any)[
      'byAssignEventOwnership'
    ]
    const isBySyncEventAcrossGroups = (error.response?.data as unknown as any)[
      'bySyncEventAcrossGroups'
    ]

    if (code === EDIT_EVENT_CAN_CHANGE_ONLY_OWNERS) {
      if (eventId && eventId.length > 0) fetchAndSaveEventFromServer(eventId)
      return i18n.t('thisCalendarAllows')
    }
    if (
      code === EDIT_EVENT_CANNOT_CHANGE_EVENT ||
      code === ADD_EVENT_CANNOT_POST_ITEMS
    ) {
      if (eventId && eventId.length > 0) fetchAndSaveEventFromServer(eventId)

      return i18n.t('thisEventPartOf')
    } else if (code === OUT_OF_TIER) {
      if (eventId && eventId.length > 0) fetchAndSaveEventFromServer(eventId)
      if (isByRSVP) {
        return i18n.t('thisCalendarDoesntAllow', {
          feature: i18n.t('rsvpForEvents')
        })
      }
      if (isByEventOwnership) {
        return i18n.t('thisCalendarDoesntAllow', {
          feature: i18n.t('assignEventOwnership')
        })
      }
      if (isBySyncEventAcrossGroups) {
        return i18n.t('thisCalendarDoesntAllow', {
          feature: i18n.t('syncEventsAcrossCalendars')
        })
      }

      return i18n.t('calendarBlockedForChanges')
    }
  }

  return GENERIC_ERROR
}

export function prepareCalendars(
  account: Model<AccountDoc> | AccountDoc,
  groupOrCalendarId?: string,
  addressVisibilityOnAllCalendars?: boolean
) {
  const data: SelectableItem[] = []

  data.push(
    ...CurrentConvertedCalendars.filter(
      (calendar) => calendar.accessRole != 'reader'
    ).map((calendar) => {
      return {
        id: calendar.id,
        title: calendar.name ?? ''
      }
    })
  )

  const userId = LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
  return UserSettings().then((userSettings) => {
    return allGroups().then((groups) => {
      return [
        ...allGroupsForUI(groups, userSettings, false).map((group) => {
          const isSyncProblem = group.SyncProblem === '1'
          const notShowOnAllCalendars = isGroupHidden(
            userSettings,
            group._id ?? ''
          )
          const cantOperateEventsIn = isGroupBlockedToAddEvents(
            account,
            group,
            userSettings,
            userId,
            false
          )
          const isBlocked =
            cantOperateEventsIn || isSyncProblem || notShowOnAllCalendars

          const picSize = 12
          const isConverted = isConvertedGroup(group)

          const subItems = isConverted
            ? [
                ...CurrentConvertedCalendars.filter(
                  (calendar) =>
                    calendar.accessRole !== 'reader' &&
                    calendar.prefix ===
                      groupIdToPrefix(group.CalendarEmail ?? '') &&
                    group.CalendarEmail?.includes(
                      calendar.primaryCalendarEmail ?? ''
                    )
                )
              ]
            : undefined

          let icon: ReactNode | undefined = undefined

          if (isBlocked) {
            if (isGroupHidden(userSettings, group._id ?? '')) {
              icon = <EyeCrossIcon data-icon="hide" />
            } else {
              if (isSyncProblem) {
                icon = <GoogleProblem />
              } else {
                icon = (
                  <LockIcon
                    style={{ marginRight: '1px' }}
                    width={14}
                    height={17}
                  />
                )
              }
            }
          }
          const item: SelectableItem = {
            id: group._id,
            title: isConvertedGroup(group)
              ? (removePrefix(group.CalendarEmail ?? '') ?? '')
              : group.Name,
            subItems,
            rightIcon: icon,
            photo: group.Photo,
            group: group,
            subTitle:
              groupOrCalendarId === group._id ? `${t('primaryCalendar')}` : '',
            subTitleColor:
              groupOrCalendarId === group._id ? APP_COLOR : undefined,
            notClickable:
              cantOperateEventsIn ||
              isSyncProblem ||
              (notShowOnAllCalendars && addressVisibilityOnAllCalendars),
            notClickableReason: cantOperateEventsIn
              ? `${t('youDontHavePermissions')}`
              : undefined
          }
          return item
        })
      ]
    })
  })
}

export function prepareSections(
  calendars: SelectableItem[],
  multimode: boolean,
  selectedGroupId?: string,
  SupplementaryGroupsIDs?: string[]
) {
  const sections: CalendarSectionItem[] = []

  calendars
    .filter((calendar) => {
      return (
        isConvertedGroupId(calendar.group?.CalendarEmail) &&
        calendar.group?.OwnerID === LocalStorage.get(LocalStorageKey.USER_ID)
      )
    })
    .flatMap((calendar) => {
      sections.push({
        title: `${
          isConvertedGroupId(calendar.group?.CalendarEmail)
            ? `${groupIdToProviderTypeName(calendar.group?.CalendarEmail)} - `
            : ''
        } ${removePrefix(calendar.title)}`,
        items: calendar.subItems ?? [],
        sectionIcon: calendar.rightIcon
      })
    })
  if (isGroupcalApp())
    sections.push({
      title: `${t('sharedCalendars')}`,
      items: calendars
        .filter((calendar) => {
          if (
            isConvertedGroupId(calendar.group?.CalendarEmail) &&
            calendar.group?.OwnerID ===
              LocalStorage.get(LocalStorageKey.USER_ID)
          )
            return false

          return true
        })
        .map((calendar) => {
          return {
            ...calendar,
            selected:
              calendar.id === selectedGroupId ||
              SupplementaryGroupsIDs?.includes(calendar.id ?? ''),
            notClickable: calendar.notClickable,
            notClickableReason:
              selectedGroupId === calendar.id ? `${t('primaryCalendar')}` : ''
          }
        }),

      availableMultiMode: multimode
    })

  return sections
}
